import { RouteObject } from "react-router-dom";
import { ASSETS_LIST_PATH, AssetsListPage } from "./pages/assets-list";
import { MY_ASSETS_PATH, MyAssetsPage } from "./pages/my-assets";

export const assetsAccountingRoutes: RouteObject[] = [
  {
    path: ASSETS_LIST_PATH,
    element: <AssetsListPage />,
  },
  {
    path: MY_ASSETS_PATH,
    element: <MyAssetsPage />,
  },
];
